<app-layout>
  <div class="home-element">
    <h2>
      <i class="pi pi-lightbulb"></i> Inspecciones
    </h2>

    <section class="table-container" [class.blocked-overlay]="isBlocked">
      @if (isBlocked) {
        <div class="blocked-message">
          <i class="fas fa-exclamation-triangle fa-3x mb-3"></i>
          <h4>Cuenta con adeudo pendiente</h4>
          <p>Regularice su pago para visualizar los reportes completos</p>
        </div>
      }

      <p-table
        #dt2
        [value]="services"
        dataKey="id"
        [rows]="dataForm.value.page_size"
        [rowsPerPageOptions]="[10, 25, 50]"
        [loading]="loadingServices"
        [paginator]="false"
        styleClass="p-datatable-sm"
        [globalFilterFields]="['folio', 'title', 'employee.name', 'customer.name', 'customer.address']"
      >
        <ng-template pTemplate="header">
          <tr>
            <th style="width:10%" pSortableColumn="folio" class="bg-gray-100 border-bottom">
              <p class="th-inside">
                Folio <p-sortIcon field="folio" />
              </p>
            </th>

            <th style="width:18%" pSortableColumn="title" class="bg-gray-100 border-bottom">
              <p class="th-inside">
                Servicio <p-sortIcon field="title" />
              </p>
            </th>

            <th style="width:18%" pSortableColumn="date" class="bg-gray-100 border-bottom">
              <p class="th-inside">
                Fecha / Hora de servicio <p-sortIcon field="date" />
              </p>
            </th>

            <th style="width:18%" pSortableColumn="employee.name" class="bg-gray-100 border-bottom">
              <p class="th-inside">
                Técnico responsable <p-sortIcon field="employee.name" />
              </p>
            </th>

            <th style="width:18%" pSortableColumn="customer.name" class="bg-gray-100 border-bottom">
              <p class="th-inside">
                Cliente <p-sortIcon field="customer.name" />
              </p>
            </th>

            <th style="width:18%" pSortableColumn="customer.address" class="bg-gray-100 border-bottom">
              <p class="th-inside">
                Dirección <p-sortIcon field="customer.address" />
              </p>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-service>
          <tr class="text-sm">
            <td>
              <span
                class="folio"
                (click)="handleOpenModal(service)"
              >
                {{ service.folio }}
              </span>
            </td>

            <td>
              {{ service.title }}
            </td>

            <td>
              {{ service.initial_date | date: 'dd/MM/yyyy' }}
              <br />
              {{ service.initial_hour }}
            </td>

            <td>
              {{ service.employee.name }}
            </td>

            <td>
              {{ service.customer.name }}
            </td>

            <td>
              {{ service.customer.address }}
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="9">
              <p class="emptymessage">No se encontraron servicios</p>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <p-paginator
        [first]="dataForm.value.firstPage"
        [rows]="dataForm.value.page_size"
        [rowsPerPageOptions]="[10, 20, 30, 50]"
        [totalRecords]="dataForm.value.totalRecords"
        (onPageChange)="pageChange($event)"
        currentPageReportTemplate="{currentPage} de {totalPages}"
        [showJumpToPageDropdown]="true"
        [showPageLinks]="true"
        [showJumpToPageInput]="true"
      ></p-paginator>
    </section>

    <p-dialog
      [modal]="true"
      [(visible)]="isModalVisible"
      [style]="{ width: '80%' }"
    >
      <ng-template pTemplate="header">
        <h3>
          Detalle de la Inspección
        </h3>
      </ng-template>

      @if (activeService) {
        <div class="modal-header">
          <article>
            <p>
              <span class="service-data">Folio del servicio: </span>
              {{ activeService.folio }}
            </p>
            <p>
              <span class="service-data">Técnico aplicador: </span>
              {{ activeService.employee.name }}
            </p>
          </article>
        </div>

        <div class="modal-body">
          <p-table
            #dt2
            [value]="inspections"
            dataKey="id"
            [rows]="dataForm.value.page_size"
            [rowsPerPageOptions]="[10, 25, 50]"
            [loading]="loadingInspections"
            [paginator]="false"
            styleClass="p-datatable-sm"
          >
            <ng-template pTemplate="header">
              <tr>
                <th class="bg-gray-100 border-bottom">Plaga</th>
                <th class="bg-gray-100 border-bottom">Grado de infestación</th>
                <th class="bg-gray-100 border-bottom">Evidencia</th>
                <th class="bg-gray-100 border-bottom">Fotos</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-inspection>
              <tr>
                <td>{{ inspection.plague }}</td>
                <td>{{ inspection.infestationDegree }}</td>
                <td>{{ inspection.evidence_type }}</td>

                <td>
                  @if (inspection.photos.length > 0) {
                    <p-button
                      type="button"
                      icon="pi pi-images"
                      [rounded]="true"
                      class="p-button-info"
                      (click)="openPhotoModal(inspection.photos)"
                    ></p-button>
                  } @else {
                    <span class="text-gray-500">
                      No hay fotos disponibles
                    </span>
                  }
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="9">
                  <p class="emptymessage">No se encontraron inspecciones</p>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <p-paginator
            [first]="dataFormModal.value.firstPage"
            [rows]="dataFormModal.value.page_size"
            [rowsPerPageOptions]="[10, 20, 30, 50]"
            [totalRecords]="dataFormModal.value.totalRecords"
            (onPageChange)="pageChangeModal($event)"
            currentPageReportTemplate="{currentPage} de {totalPages}"
            [showJumpToPageDropdown]="true"
            [showPageLinks]="true"
            [showJumpToPageInput]="true"
          ></p-paginator>
        </div>
      }
    </p-dialog>

    <p-dialog [(visible)]="isPhotoModalVisible" [modal]="true" [style]="{ width: '60%' }">
      <ng-template pTemplate="header">
        <h3>Fotos de la Inspección</h3>
      </ng-template>

      <div class="photos-container">
        @if (selectedPhotos.length > 0) {
          @for (photo of selectedPhotos; track $index) {
            <div class="photo">
              <img [src]="photo" alt="Foto de inspección" class="photo-preview"/>
            </div>
          }
        } @else {
          <p>No hay fotos disponibles</p>
        }
      </div>
    </p-dialog>
  </div>
</app-layout>
